import React from 'react';
import { Power } from 'lucide-react';

export interface OnOffStyle02Props {
  isOn: boolean;
  disabled?: boolean;
  loading?: boolean;
  onToggle: () => void;
  size?: 'small' | 'medium' | 'large';
  label?: string;
}

/**
 * OnOff Style 02 - Toggle Switch Style
 * iOS-style sliding toggle switch
 * Hover shows target state color
 */
export const Style02_Toggle: React.FC<OnOffStyle02Props> = ({
  isOn,
  disabled = false,
  loading = false,
  onToggle,
  size = 'medium',
  label = '電源'
}) => {
  const sizeConfig = {
    small: { track: 'w-10 h-5', thumb: 'w-4 h-4', translate: 'translate-x-5', icon: 'w-3 h-3' },
    medium: { track: 'w-14 h-7', thumb: 'w-6 h-6', translate: 'translate-x-7', icon: 'w-4 h-4' },
    large: { track: 'w-20 h-10', thumb: 'w-9 h-9', translate: 'translate-x-10', icon: 'w-5 h-5' }
  };

  const config = sizeConfig[size];

  return (
    <div className="flex items-center justify-between">
      {label && (
        <div className="flex items-center gap-2">
          <Power className={`${config.icon} ${isOn ? 'text-green-400' : 'text-slate-500'}`} />
          <span className="text-sm font-medium text-slate-300">{label}</span>
        </div>
      )}
      <button
        onClick={onToggle}
        disabled={disabled || loading}
        className={`${config.track} relative rounded-full transition-colors duration-300 ${
          isOn 
            ? 'bg-green-500 hover:bg-red-400' 
            : 'bg-slate-700 hover:bg-green-400'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        title={isOn ? '點擊關閉' : '點擊開啟'}
      >
        <span
          className={`${config.thumb} absolute top-0.5 left-0.5 rounded-full bg-white shadow-md transform transition-transform duration-300 ${
            isOn ? config.translate : 'translate-x-0'
          } flex items-center justify-center`}
        >
          {loading && (
            <span className="animate-spin w-3 h-3 border-2 border-slate-300 border-t-transparent rounded-full" />
          )}
        </span>
      </button>
    </div>
  );
};

export default Style02_Toggle;
